export default __webpack_public_path__ + "static/media/profilepic.6efa9640.jpg";